import './subscribe.less'

import Button from 'views/layout/button'
import ContentContainer from 'views/layout/contentcontainer'
import Layout from 'views/layout'
import OptinForm from 'forms/optinform'
import Wysiwyg from 'views/layout/wysiwyg'
import {WysiwygType} from 'types/types'
import m from 'mithril'
import {t} from 'store'

type SubscribeType = {
	description?: WysiwygType
	form_title: string
	form_text: WysiwygType
	form_firstname_label?: string
	form_firstname_placeholder?: string
	form_lastname_label?: string
	form_lastname_placeholder?: string
	form_organisation_label?: string
	form_organisation_placeholder?: string
	form_email_label?: string
	form_email_placeholder?: string
	thanks_title: string
	thanks_text: WysiwygType
}

export default class Subscribe extends Layout<SubscribeType> {
	getUrlParameters = (value: string) => {
		const query = window.location.search
		const paramsObj =
			query && query[0] === '?' && query.length > 1
				? m.parseQueryString(query.substring(1))
				: {}
		for (const key in paramsObj) {
			if (key === value) {
				return paramsObj[key]
			}
		}
		return undefined
	}

	form: any = new OptinForm({
		data: {
			email: this.getUrlParameters('email')
		}
	})
	isCompleted = false
	errors = []

	getErrors(key: string) {
		return this.errors && this.errors[key]
	}

	view() {
		return m('.subscribe', [
			m(ContentContainer, [
				this.viewIntro(),
				this.isCompleted ? this.viewThanks() : this.viewForm()
			])
		])
	}

	viewIntro() {
		const {description} = this.attrs.data
		if (!description) return null

		return m('.subscribe-intro', [
			m(Wysiwyg, {
				class: 'subscribe-intro-description',
				mod: 'intro',
				html: description
			})
		])
	}

	onChangeHandler = (e: Event, field: string) => {
		const target = e.target as HTMLInputElement
		const value = target.type === 'checkbox' ? target.checked : target.value
		this.form.store.setData(field, value)
	}

	viewForm() {
		const {
			form_title,
			form_text,
			form_firstname_label,
			form_firstname_placeholder,
			form_lastname_label,
			form_lastname_placeholder,
			form_organisation_label,
			form_organisation_placeholder,
			form_email_label,
			form_email_placeholder,
			links
		} = this.attrs.data

		return m('form.subscribe-form',
			{
				onsubmit: e =>
					this.form
						.formSubmit(e)
						.then(_ => (this.isCompleted = true))
						.catch(err => {
							const parsedError = JSON.parse(JSON.stringify(err))
							this.errors = parsedError.response
						})
			},
			[
				form_title && m('h2.subscribe-form-title', form_title),
				form_text &&
					m(Wysiwyg, {class: 'subscribe-form-text', html: form_text}),
				m('.subscribe-form-row', [
					m('label.subscribe-form-field', [
						m('p.subscribe-form-field-label',
							(t('subscribe.form.firstname_label') || form_firstname_label) +
								' *'
						),
						m('input.subscribe-form-field-input', {
							type: 'text',
							name: 'firstname',
							required: true,
							placeholder: form_firstname_placeholder,
							onchange: (e: Event) => this.onChangeHandler(e, 'firstname')
						})
					]),
					m('label.subscribe-form-field', [
						m('p.subscribe-form-field-label',
							(t('subscribe.form.lastname_label') || form_lastname_label) + ' *'
						),
						m('input.subscribe-form-field-input', {
							type: 'text',
							name: 'lastname',
							required: true,
							placeholder: form_lastname_placeholder,
							onchange: (e: Event) => this.onChangeHandler(e, 'lastname')
						})
					])
				]),
				m('.subscribe-form-row', [
					m('label.subscribe-form-field', [
						m('p.subscribe-form-field-label',
							(t('subscribe.form.organisation_label') ||
								form_organisation_label) + ' *'
						),
						m('input.subscribe-form-field-input', {
							type: 'text',
							name: 'company',
							required: true,
							placeholder: form_organisation_placeholder,
							onchange: (e: Event) => this.onChangeHandler(e, 'company')
						})
					]),

					m('label.subscribe-form-field', [
						m('p.subscribe-form-field-label',
							(t('subscribe.form.email_label') || form_email_label) + ' *'
						),
						m('input.subscribe-form-field-input', {
							type: 'email',
							name: 'email',
							required: true,
							placeholder: form_email_placeholder,
							defaultValue: this.getUrlParameters('email'),
							onchange: (e: Event) => this.onChangeHandler(e, 'email')
						})
					])
				]),
				m('label.subscribe-form-checkbox', [
					m('input.subscribe-form-checkbox-input', {
						type: 'checkbox',
						name: 'privacy_policy_acceptance',
						required: true,
						onchange: (e: Event) =>
							this.onChangeHandler(e, 'privacy_policy_acceptance')
					}),
					m('span.subscribe-form-checkbox-label', [
						m('span.subscribe-form-checkbox-label-inputnew'),
						m('span', t('subscribe.form.privacy_label')),
						m('a.subscribe-form-checkbox-label-link',
							{
								href: links.privacy ? links.privacy.url : '#',
								target: '_blank'
							},
							t('subscribe.form.privacy_link')
						)
					])
				]),
				m('.subscribe-form-submit', [
					m(Button,
						{type: 'submit', class: 'subscribe-form-submit-btn', mod: 'round'},
						t('subscribe.form.submit')
					)
				])
			]
		)
	}

	viewThanks() {
		const {thanks_title, thanks_text} = this.attrs.data

		return m('.subscribe-thanks', [
			m('h2.subscribe-thanks-title',
				thanks_title || t('subscribe.thanks.title')
			),
			thanks_text
				? m(Wysiwyg, {
						class: 'subscribe-thanks-text',
						html: thanks_text
				  })
				: m('p.subscribe-thanks-text', t('subscribe.thanks.text'))
		])
	}
}
